import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, TruckIcon } from 'lucide-react';
export const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-57">
      <nav className="container mx-auto px-4 py-4 flex items-center justify-between" data-id="element-58">
        <Link to="/" className="flex items-center gap-2" data-id="element-59">
          <TruckIcon className="h-8 w-8 text-blue-600" data-id="element-60" />
          <span className="text-xl font-bold text-gray-800" data-id="element-61">MoveEst</span>
        </Link>
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8" data-id="element-62">
          <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-63">
            Home
          </Link>
          <Link to="/order" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-64">
            Book a Move
          </Link>
          <Link to="/tracking" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-65">
            Track Order
          </Link>
          <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-66">
            Services
          </Link>
          <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-67">
            Contact
          </Link>
          <Link to="/order" className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors" data-id="element-68">
            Book Now
          </Link>
        </div>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-700" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-69">
          {isMenuOpen ? <XIcon size={24} data-id="element-70" /> : <MenuIcon size={24} data-id="element-71" />}
        </button>
      </nav>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white border-t" data-id="element-72">
          <div className="container mx-auto px-4 py-2 flex flex-col" data-id="element-73">
            <Link to="/" className="py-3 text-gray-700 hover:text-blue-600 font-medium border-b border-gray-100" onClick={toggleMenu} data-id="element-74">
              Home
            </Link>
            <Link to="/order" className="py-3 text-gray-700 hover:text-blue-600 font-medium border-b border-gray-100" onClick={toggleMenu} data-id="element-75">
              Book a Move
            </Link>
            <Link to="/tracking" className="py-3 text-gray-700 hover:text-blue-600 font-medium border-b border-gray-100" onClick={toggleMenu} data-id="element-76">
              Track Order
            </Link>
            <Link to="/" className="py-3 text-gray-700 hover:text-blue-600 font-medium border-b border-gray-100" onClick={toggleMenu} data-id="element-77">
              Services
            </Link>
            <Link to="/" className="py-3 text-gray-700 hover:text-blue-600 font-medium" onClick={toggleMenu} data-id="element-78">
              Contact
            </Link>
            <Link to="/order" className="bg-blue-600 text-white mt-4 py-3 rounded-md text-center hover:bg-blue-700 transition-colors" onClick={toggleMenu} data-id="element-79">
              Book Now
            </Link>
          </div>
        </div>}
    </header>;
};